<script lang="ts">
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "JaNeinRadio",
  props: {
    name: String,
    modelValue: Boolean,
  },
  setup(props) {
    return {
      jaLabel: computed(() => props.name + "Ja"),
      neinLabel: computed(() => props.name + "Nein"),
    };
  },
});
</script>

<template>
  <div class="mkRadio">
    <input
      type="radio"
      :id="neinLabel"
      :name="name"
      @input="$emit('update:modelValue', false)"
      :checked="false === modelValue"
      :value="false"
      :data-cy="neinLabel"
      required
      aria-required="true"
      aria-label="Nein"
    />
    <label :for="neinLabel" class="radiolabel">Nein</label>
    <input
      type="radio"
      :id="jaLabel"
      :name="name"
      @input="$emit('update:modelValue', true)"
      :checked="true === modelValue"
      :value="true"
      :data-cy="jaLabel"
      aria-label="Ja"
    />
    <label :for="jaLabel" class="radiolabel">Ja</label>
  </div>
</template>
